package com.macrofocus.eflux.ui.bar

import com.macrofocus.eflux.components.EFluxContext
import mui.icons.material.*
import mui.material.Box
import mui.material.FabColor
import mui.system.sx
import org.mkui.react.useProperty
import react.FC
import react.Props
import react.useRequired
import web.cssom.*

external interface WestFabBarProps : Props {
}

public val WestFabBar = FC<WestFabBarProps> { props ->
    val context = useRequired(EFluxContext)

    val (expert, _) = useProperty(context.dataLoader.exportMode)

    // Maintain toggle states
    val (aboutSelected, setAboutSelected) = useProperty(context.showAbout)
    val (searchSelected, setSearchSelected) = useProperty(context.showSearch)
    val (historySelected, setHistorySelected) = useProperty(context.showClock)

    val (autoMorphing, _) = useProperty(context.dataLoader.autoMorphing)
    val (autoTerrain, _) = useProperty(context.dataLoader.autoTerrain)
    val (terrain, _) = useProperty(context.dataLoader.terrain)
    val (schemas, _) = useProperty(context.dataLoader.schemas)

    Box {
        sx {
            position = Position.absolute
            top = 0.px
            left = 16.px
            height = 100.pct
            display = Display.flex
            flexDirection = FlexDirection.column
            justifyContent = JustifyContent.spaceBetween // Top & Bottom groups
            gap = 16.px
            paddingTop = 16.px
        }

        // Top group
        Box {
            sx {
                display = Display.flex
                flexDirection = FlexDirection.column
                gap = 16.px
            }

            // About toggle FAB
            LiquidFab {
                color = if (aboutSelected) FabColor.primary else FabColor.default
                onClick = { setAboutSelected(!aboutSelected) }

                ariaLabel = "About"
                InfoTwoTone {}
            }

            // Search toggle FAB
            LiquidFab {
                color = if (searchSelected) FabColor.primary else FabColor.default
                onClick = { setSearchSelected(!searchSelected) }

                ariaLabel = "Search"
                SearchTwoTone {}
            }

            // History/Clock toggle FAB
            LiquidFab {
                color = if (historySelected) FabColor.primary else FabColor.default
                onClick = { setHistorySelected(!historySelected) }

                ariaLabel = "Clock"
                HistoryTwoTone {}
            }
        }

        // Bottom group
        Box {
            sx {
                display = Display.flex
                flexDirection = FlexDirection.column
                gap = 0.px
                marginBottom = 16.px
            }

            if(expert) {
                LiquidFab {
                    color = FabColor.default
                    disabled = true
                    SettingsTwoTone {}
                }
            }

            LiquidFab {
                color = if (!autoMorphing && !terrain) FabColor.primary else FabColor.default

                sx {
                    marginBottom = -6.px
                    if(!autoMorphing && !terrain) {
                        zIndex = "2000".unsafeCast<ZIndex>()
                    }
                }

                ariaLabel = "Terrain"
                TerrainTwoTone {}

                onClick = {
                    if (context.dataLoader.autoMorphing.value || context.dataLoader.terrain.value) {
                        context.dataLoader.autoMorphing.value = false

                        context.dataLoader.autoTerrain.value = false
                        context.dataLoader.cartographic.value = 10.0
                        context.dataLoader.terrain.value = false

                        context.dataLoader.schemas.value = false
                    } else {
                        context.dataLoader.autoMorphing.value = true
                        context.dataLoader.autoTerrain.value = true
                        context.dataLoader.cartographic.value = 0.0
                        context.dataLoader.terrain.value = false
                    }
                }
            }

            LiquidFab {
                color = if (!autoMorphing && terrain) FabColor.primary else FabColor.default

                ariaLabel = "Satellite"
                SatelliteTwoTone {}

                sx {
                    if(!autoMorphing && terrain) {
                        zIndex = "2000".unsafeCast<ZIndex>()
                    }
                }


                onClick = {
                    if (context.dataLoader.autoMorphing.value || !context.dataLoader.terrain.value) {
                        context.dataLoader.autoMorphing.value = false

                        context.dataLoader.autoTerrain.value = false
                        context.dataLoader.cartographic.value = 10.0
                        context.dataLoader.terrain.value = true

                        context.dataLoader.schemas.value = false
                    } else {
                        context.dataLoader.autoMorphing.value = true
                        context.dataLoader.autoTerrain.value = true
                        context.dataLoader.cartographic.value = 0.0
                        context.dataLoader.terrain.value = false
                    }
                }
            }

            LiquidFab {
                color = if (schemas) FabColor.primary else FabColor.default

                sx {
                    marginTop = -6.px
                    if(schemas) {
                        zIndex = "2000".unsafeCast<ZIndex>()
                    }
                }

                ariaLabel = "Schemas"
                SchemaTwoTone {}

                onClick = {
                    if (context.dataLoader.schemas.value) {
                        context.dataLoader.schemas.value = false
                    } else {
                        context.dataLoader.autoMorphing.value = true
                        context.dataLoader.autoTerrain.value = true
                        context.dataLoader.cartographic.value = 0.0

                        context.dataLoader.terrain.value = false

                        context.dataLoader.schemas.value = true
                    }
                }
            }

            if(expert) {
                LiquidFab {
                    color = FabColor.inherit
                    LayersTwoTone {}
                }
            }
        }
    }
}